import SimpleSpinner from '../Icons/SimpleSpinner';

export default function LoadingSpinner() {
  return (
    <div className="flex justify-center items-center h-52">
      <SimpleSpinner />
    </div>
  );
}
